import { FC } from 'react';
import { Tag, css } from '@appd/uik';
import { Table } from '@tanstack/react-table';
import { TableColumn, PADDING, SPACING } from '../DataGrid';
import { useThreshold } from './useThreshold';
import { Threshold } from './models';
import { TAG_CELL_RENDERER_DEFAULT_THRESHOLDS } from './constants';

interface GenericCellRendererProps {
  value: string;
  thresholds: Threshold[];
  table?: Table<TableColumn>;
}

export const TagCellRenderer: FC<GenericCellRendererProps> = ({
  value,
  thresholds = TAG_CELL_RENDERER_DEFAULT_THRESHOLDS,
  table,
}) => {
  const threshold = useThreshold(thresholds, value);
  const spacing = table?.options?.meta?.spacing ?? SPACING.COMPACT;
  const padding = PADDING[spacing];

  if (!threshold?.name || !threshold?.icon || !threshold?.backgroundColor) {
    return null;
  }

  return (
    <div style={{ padding, margin: -padding }}>
      <Tag.Group
        className={css({
          '> li': { position: 'inherit' }, // Override to prevent tags from overlapping the header`.
        })}
      >
        <Tag prefix={threshold.icon} style={{ backgroundColor: threshold.backgroundColor }}>
          {threshold.name}
        </Tag>
      </Tag.Group>
    </div>
  );
};
